import { Spacer, Skeleton, Box } from '@aircall/tractor-v2';

export function AgentRolesPickerLoading() {
  return (
    <Box
      padding='s'
      backgroundColor='white'
      borderRadius='sm'
      data-test='agent-roles-picker-loading'
    >
      {[...Array(3).keys()].map((n) => (
        <Spacer key={n} space='s' p='10px 16px' borderRadius={8} w='100%' alignItems='center'>
          <Skeleton w={24} h={24} shape='squircle' />
          <Spacer space='xxs' direction='vertical'>
            <Skeleton w={105} h={8} />
            <Skeleton w={205} h={16} />
          </Spacer>
        </Spacer>
      ))}
    </Box>
  );
}
